import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { GoogleTagManagerModule } from 'angular-google-tag-manager';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ToolboxModule } from './shared/toolbox/toolbox.module';
import { LandingModule } from './landing/landing.module';
import { ProfilesModule } from './profiles/profiles.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExploreModule } from './explore/explore.module';
import { AuthInterceptor } from './services/rx-auth/rx-auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TestModule } from './test/test.module';
import { ChartsModule } from './shared/toolbox/charts/charts.module';
import { SsrModule } from './ssr/ssr.module';
import { PublicChartModule } from './public-chart/public-chart.module';
import { ListsModule } from './lists/lists.module';
import {HeaderComponent} from './shared/toolbox/header/header.component';
import {SidebarComponent} from './shared/toolbox/sidebar/sidebar.component';
import {LoaderComponent} from './shared/toolbox/loader/loader.component';
import { ProfileWrapperComponent } from './profiles/profile-wrapper/profile-wrapper.component';
import { DashboardComponent } from './profiles/dashboard/dashboard.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {LbDashboardComponent} from "./lbarometer/lb-dashboard/lb-dashboard.component";
import { LbFooterComponent } from './lbarometer/shared/lb-footer/lb-footer.component';
import { LbSidebarComponent } from './lbarometer/shared/lb-sidebar/lb-sidebar.component';
import {OfflineModalComponent} from "./shared/toolbox/offline-modal/offline-modal.component";

@NgModule({
  declarations: [AppComponent],
	imports: [
		BrowserModule,
		CommonModule,
		AppRoutingModule,
		HttpClientModule,
		ToolboxModule,
		LandingModule,
		ProfilesModule,
		BrowserAnimationsModule,
		ProfilesModule,
		ExploreModule,
		TestModule,
		SsrModule,
		ChartsModule,
		PublicChartModule,
		ListsModule,
		HeaderComponent,
		SidebarComponent,
		LoaderComponent,
		FontAwesomeModule,
		LbFooterComponent,
		LbSidebarComponent,
    OfflineModalComponent
	],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor, //AuthInterceptor located in rx-auth service
      multi: true,
    },
    MatSnackBar,
	{
		provide:'googleTagManagerId', useValue:'GTM-TVPRLXF3'
	}

  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
